const PAYMENT_METHOD_LABELS = {
  pix: "Pix",
  boleto: "Boleto",
  credit_card: "Cartão de crédito",
  bank_slip_yapay: "Boleto",
  billet: "Boleto",
  cash: "Dinheiro",
  hybrid: "Híbrido",
  pix_automatic: "Pix",
  wallet: "Wallet",
};

export function paymentMethodText(paymentType) {
  return PAYMENT_METHOD_LABELS[paymentType.toLowerCase()] || paymentType;
}

export function purchaseStatusVariant(purchase) {
  const status = purchase.groupStatus || purchase.status || "";

  if (status === "refunded" || purchase.status === "charge.refunded" || purchase.status === "bill_canceled") {
    return { text: "Reembolsada", background: "#F8FAFC", border: "#CBD5E1", color: "#64748B" };
  }

  if (
    status === "sell" ||
    ["approved", "charge.paid", "paid", "confirmed", "bill_paid"].includes(purchase.status)
  ) {
    return { text: "Concluída", background: "#F0FDF4", border: "#BBF7D0", color: "#379C5C" };
  }

  if (["canceled", "dispute", "chargeback", "charge.partial_canceled"].includes(purchase.status)) {
    return { text: "Negada", background: "#FEF2F2", border: "#FECACA", color: "#B91C1C" };
  }

  return { text: "Em análise", background: "#FFF7ED", border: "#FED7AA", color: "#EA580C" };
}

export function findInvoiceLink(purchase, invoices) {
  const direct =
    purchase.invoiceLink ||
    purchase.invoiceUrl ||
    purchase.additionalAttributes?.invoiceLink ||
    purchase.additionalAttributes?.invoiceUrl;
  if (direct) return direct;

  const match = invoices.find(
    (inv) =>
      (inv.transactionCode && inv.transactionCode === purchase.transactionCode) ||
      (inv.productName && inv.productName === purchase.productName)
  );

  return match?.link || null;
}

export function purchaseCode(purchase, index) {
  const num = String(index + 1).padStart(3, "0");
  return `PUR-${num}`;
}
